import {AppEvent} from '@esgillc/events';

@AppEvent()
export class ESGI25518LongResponseTime {
}